module.exports = __webpack_public_path__ + "img/volver-figura.6578f876.svg";